<template>
  <div v-loading="loading.ruleDeliverFlowSearchById">
    <div class="header">
      <h3>流程设置</h3>
    </div>
    <list-block>
      <el-form
        ref="form"
        :rules="rules"
        :inline="true"
        :model="form"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="流程编码:" prop="ruleCode">
              <el-input v-model="form.ruleCode" :disabled="isDetail" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流程描述:" prop="description">
              <el-input v-model="form.description" :disabled="isDetail" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="header">
          <h4>流程前置条件</h4>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单类型:" prop="orderType">
              <el-select
                v-model="form.orderType"
                placeholder="请选择订单类型"
                :disabled="isDetail"
              >
                <el-option
                  v-for="item in IN_ORDER_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库:" prop="warehouseCode">
              <el-select
                v-model="form.warehouseCode"
                placeholder="请选择仓库"
                :disabled="isDetail"
                filterable
                @change="handleSelect"
              >
                <el-option
                  v-for="(item, index) in warehouseList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseCode"
                />
              </el-select>
            </el-form-item>
            <el-checkbox
              v-model="form.isDefault"
              style="margin-top: -20px"
              :disabled="isDetail"
            >
              设为默认流程
            </el-checkbox>
          </el-col>
          <el-col :span="8">
            <el-form-item label="货主:" prop="shippers.infos">
              已选择<span class="special-color">{{ form.shippers.infos.length }} </span>个货主
              <el-button
                type="text"
                @click="handleEdit"
              >
                编辑
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="header">
          <h4>流程配置</h4>
        </div>
        <el-row style="margin: 10px 0;">
          <el-steps
            :space="200"
            :active="stepActive"
            finish-status="success"
          >
            <el-step
              v-for="(item, index) in warehousingStep"
              :key="index"
              :title="item.name"
              @click.native="chegeFlowPath(item.uri,index)"
            />
          </el-steps>
        </el-row>
        <div
          v-if="showSwitchBox"
          class="switch-box"
        >
          <create-order
            v-show="nowFlowPath === warehousingFlowPath.RECEIPT_ORDER_CREATE_NODE"
            ref="createOrderEl"
            :is-detail="isDetail"
            :form-data="form.configCreateOrder"
          />
          <accepting-order
            v-show="nowFlowPath === warehousingFlowPath.RECEIPT_ORDER_ACCEPTING_NODE"
            ref="acceptingOrderEl"
            :is-detail="isDetail"
            :form-data="form.configAcceptingOrder"
          />
          <arrival-reservation
            v-show="nowFlowPath === warehousingFlowPath.RECEIPT_RESERVATION_NODE"
            ref="arrivalReservation"
            :is-detail="isDetail"
            :form-data.sync="form.configReservation"
          />
          <arrival-registration
            v-show="nowFlowPath === warehousingFlowPath.RECEIPT_CHECK_IN_NODE"
            ref="arrivalRegistration"
            :is-detail="isDetail"
            :form-data="form.configCheckIn"
          />
          <check-and-accept
            v-show="nowFlowPath === warehousingFlowPath.RECEIPT_ORDER_ACCEPT_NODE"
            ref="checkAndAccept"
            :is-detail="isDetail"
            :form-data="form.configAccept"
            :warehouse-code="form.warehouseCode"
            :warehouse-id="form.warehouseId"
            @resetDefaultQa="resetDefaultQa"
            @resetOverchargePercent="resetOverchargePercent"
          />
          <grounding
            v-show="nowFlowPath === warehousingFlowPath.RECEIPT_ORDER_PUTAWAY_NODE"
            ref="grounding"
            :is-detail="isDetail"
            :form-data="form.configPutaway"
            :warehouse-code="form.warehouseCode"
            :warehouse-id="form.warehouseId"
            @resetStorehouseCode="resetStorehouseCode"
          />
        </div>
        <el-form-item class="btn-boxs">
          <el-button
            v-if="!isDetail"
            :loading="loading.submit"
            type="primary"
            @click="onSubmit"
          >
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </list-block>
    <select-dialog
      ref="dialogSelect"
      :warehouse-code="form.warehouseCode"
      :order-type="form.orderType"
      @onSuccess="handleIds"
    />
  </div>
</template>

<script>
/* eslint-disable */
import ListBlock from '@/components/ListBlock/index.vue';
import { getDictionary } from '@/utils/Dictionary';

import { getWarehouseList } from '@/api/warehouse';
import {
  warehousingProcessUpdateNew,
  warehousingProcessDetailNew,
} from '@/api/configure/warehousingProcess';
import {
  getTaskByNode,
  geIsDefaultInFlow,
} from '@/api/configure/outboundProcess';
import loadingMixin from '@thales/loading';
import { WUJIE_EVENT_NAME } from '@/utils/subWujie/event';
import createOrder from './components/createOrder.vue';
import arrivalReservation from './components/arrivalReservation.vue';
import arrivalRegistration from './components/arrivalRegistration.vue';
import checkAndAccept from './components/checkAndAccept.vue';
import grounding from './components/grounding.vue';
import SelectDialog from '../components/SelectDialog.vue';
import AcceptingOrder from './components/acceptingOrder.vue'
import {
  PAGE_TYPE, warehousingFlowPath, warehousingStep,
  IN_ORDER_TYPE,
} from '../constant';

export default {
  provide() {
    return {
      activedSteps: () => this.getActivedSteps,
      stepActive: () => this.stepActive,
      systemTableData: () => this.getSystemTableData(),
      getNodeTableData: (nodeType) => this.getNodeTableData(nodeType),
      taskAllTableData: () => this.taskAllTableData,
      isDetail: this.isDetail,
    };
  },
  components: {
    ListBlock,
    createOrder,
    arrivalReservation,
    arrivalRegistration,
    checkAndAccept,
    grounding,
    SelectDialog,
    AcceptingOrder,
  },
  mixins: [loadingMixin],
  data() {
    return {
      warehousingFlowPath,
      warehousingStep,
      IN_ORDER_TYPE,
      stepActive: 0,
      showSwitchBox: false,
      warehouseList: [],
      form: {
        ruleCode: '', // 流程编码
        description: '', // 流程描述
        orderType: '', // 订单类型code
        warehouseCode: '', // 仓库code
        isDefault: false, // 是否设为默认流程
        shippers: {
          infos: [],
        }, // 货主
        // 流程数据
        configCreateOrder: {}, // 创建订单
        configReservation: { // 到货预约
          openPoint: false,
        },
        configCheckIn: { // 到货登记
          openPoint: false,
        },
        configAccept: { // 验收
          goodsQualityList: [],
          defaultGoodsQuality: '',
          allowOvercharge: false,
          overchargePercent: 0,
          allowContainerMixBatch: true,
          allowContainerMixGoods: true,
          enableGoodsTagCode: false,
          validateGoodsTagCode: false,
          validateVeneerNum: false,
          supplierAllowAcceptance: false, // 供应商端是否允许验收
          isValidatorNewProduct: false, // 是否验证新品
          temporaryStorehouse: {
            normalLocationCode: '',
            refrigerateLocationCode: '',
            coldLocationCode: '',
            constantLocationCode: '',
          },
          isSkipContainer: false,
        },
        configPutaway: { // 上架
          allowCrossDockingAndPutaway: true,
          autoPutawayStorehouseCode: '', // 越库自动上架库位
          nonCrossPutawayStorehouseCode: '', // 非越库自动上架库位
          nonCrossPutawayStorehouseId: '',
          isConfirmPutawayAmount: false,
          isScanPutawayContainer: false,
          isEntireOrderNotify: true,
          isSingleListingNotify: false, // 是否单次上架回传（与整单回传并列配置）
        },
        configAcceptingOrder: { // 接单
          autoAcceptingOrder: true,
        }
      },
      goodsQualityList: [],
      nowFlowPath: warehousingStep[0].uri,
      loading: {
        ruleDeliverFlowSearchById: false,
        submit: false,
      },
      rules: {
        ruleCode: [
          { required: true, message: '请输入流程编码', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入流程描述', trigger: 'blur' },
        ],
        orderType: [
          { required: true, message: '请选择订单类型', trigger: 'change' },
        ],
        warehouseCode: [
          { required: true, message: '请选择仓库', trigger: 'change' },
        ],
        'shippers.infos': [
          { required: true, message: '请选择货主', trigger: 'change' },
        ],
      },
      taskAllTableData: [],
    };
  },
  created() {
    this.init();
  },
  computed: {
    getActivedSteps() {
      return warehousingStep.slice(0, this.stepActive + 1);
    },
    isDetail() {
      return this.$route.query.type === PAGE_TYPE.VIEW;
    },
  },
  methods: {
    // 初始化获取数据
    async init() {
      this.getDictionary();
      // 获取仓库下拉列表
      this.getWarehouseList();
      this.getAllTaskData();
      if (this.$route.query.type && this.$route.query.id) {
        await this.ruleDeliverFlowSearchById();
      }
    },
    getDictionary() {
      const goodsQualityList = getDictionary(this.$store.state.dictionary.dictionaryCodeEN.GOODS_QUALITY);
      if (this.form.configAccept.goodsQualityList.length === 0) {
        this.form.configAccept.goodsQualityList = [goodsQualityList[0]?.code];
      }
      if (!this.form.configAccept.defaultGoodsQuality) {
        this.form.configAccept.defaultGoodsQuality = goodsQualityList[0]?.code;
      }
    },
    async getWarehouseList() {
      const warehouseList = await getWarehouseList({}, {
        page: 1,
        size: 9999,
      });
      this.warehouseList = warehouseList.records;
    },
    async getAllTaskData() {
      const res = await getTaskByNode({});
      this.taskAllTableData = res;
      this.showSwitchBox = true;
    },
    // 根据id获取
    async ruleDeliverFlowSearchById() {
      const res = await warehousingProcessDetailNew({ id: this.$route.query.id });
      this.form = {
        ...res,
      };
      // 兼容历史数据：接口未下发 isSingleListingNotify 时补默认，避免上架节点校验无法通过
      if (
        this.form.configPutaway
        && typeof this.form.configPutaway.isSingleListingNotify !== 'boolean'
      ) {
        this.$set(this.form.configPutaway, 'isSingleListingNotify', false);
      }
      if (!res.configAccept.isValidatorNewProduct) {
        this.form.configAccept.isValidatorNewProduct = false;
      }
      if (!res.configAccept.isSkipContainer) {
        this.form.configAccept.isSkipContainer = false;
      }
      this.form.updateTime = null;
      // 复制
      if (Number(this.$route.query.num) === 2) {
        this.form.ruleCode = '';
        this.form.description = '';
        this.form.orderType = '';
        this.form.warehouseCode = '';
        this.form.isDefault = false;
        this.form.shippers.infos = [];
        this.form.id = '';
      }
    },
    resetStorehouseCode() {
      this.form.configPutaway.autoPutawayStorehouseCode = '';
    },
    // 改变出库流程配置
    chegeFlowPath(data, index) {
      this.stepActive = index;
      this.nowFlowPath = data;
      const getTableDataMap = this.getNodeToEl();
      getTableDataMap[this.nowFlowPath].resetTaskOptions();
    },
    // 进行表单及表格数据验证
    formValidation() {
      return new Promise(async (resolve) => {
        try {
          await this.$refs.form.validate();
          const createOrderTable = await this.$refs.createOrderEl.validateForm();
          const acceptingOrderTable = await this.$refs.acceptingOrderEl.validateForm()
          const arrivalReservationTable = await this.$refs.arrivalReservation.validateForm();
          const arrivalRegistrationTable = await this.$refs.arrivalRegistration.validateForm();
          const checkAndAcceptTable = await this.$refs.checkAndAccept.validateForm();
          const groundingTable = await this.$refs.grounding.validateForm();
          // console.log(checkAndAcceptTable);
          resolve({
            createOrderTable,
            acceptingOrderTable,
            arrivalReservationTable,
            arrivalRegistrationTable,
            checkAndAcceptTable,
            groundingTable,
          });
        } catch (error) {}
      });
    },
    getSubmitData(tableDatas) {
      this.form.configCreateOrder.taskItemDetails = tableDatas.createOrderTable;
      this.form.configReservation.taskItemDetails = tableDatas.arrivalReservationTable;
      this.form.configCheckIn.taskItemDetails = tableDatas.arrivalRegistrationTable;
      this.form.configAccept.taskItemDetails = tableDatas.checkAndAcceptTable;
      this.form.configPutaway.taskItemDetails = tableDatas.groundingTable;
    },
    async onSubmit() {
      const tableDatas = await this.formValidation();
      if (this.form.isDefault) {
        this.checkIsDefault(tableDatas);
      } else {
        this.warehousingProcessUpdateNew(tableDatas);
      }
    },
    // 提交前校验是否已经是默认流程
    async checkIsDefault(tableDatas) {
      const res = await geIsDefaultInFlow({
        warehouseCode: this.form.warehouseCode,
        orderType: this.form.orderType,
        id: this.$route.query.id,
      });
      if (res.id && res.id != this.$route.query.id) {
        await this.$confirm(`${res.ruleCode}+${res.description}，已经设为默认，是否替换原默认流程`);
        this.warehousingProcessUpdateNew(tableDatas);
      } else {
        this.warehousingProcessUpdateNew(tableDatas);
      }
    },
    async warehousingProcessUpdateNew(tableDatas) {
      this.getSubmitData(tableDatas);
      // console.log(this.form);
      this.loading.submit = true;
      if (this.$route.query.num == 2) { // 赋值等同于新增，删除租户信息
        this.form.tenantId = '';
        this.form.tenantName = '';
      }
      try {
        await warehousingProcessUpdateNew({ ...this.form });
        this.$message.success('保存成功！');
        this.loading.submit = false;
        setTimeout(() => {
          const routeUrl = this.$router.resolve({
            path: '/cloudWarehouse/processConfig',
          });
          if (window.$wujie) {
            window.$wujie.bus.$emit(WUJIE_EVENT_NAME.CLOSE_MAIN_ROUTE, this.$route.path);

            window.$wujie.bus.$emit(WUJIE_EVENT_NAME.SUB_ROUTE_CHANGE, {
              path: routeUrl.route.fullPath,
            });
          } else {
            window.close();
          }
        }, 1000);
      } catch (error) {
        this.loading.submit = false;
      }
    },
    handleSelect(val) {
      this.form.warehouseId = this.warehouseList.filter((i) => i.warehouseCode === val)[0].id;
      this.form.configAccept.temporaryStorehouse = {
        normalLocationCode: '',
        refrigerateLocationCode: '',
        coldLocationCode: '',
        constantLocationCode: '',
      };
      this.form.configPutaway.autoPutawayStorehouseCode = '';
      this.form.shippers.infos = [];
    },
    handleEdit() {
      if (this.form.warehouseCode && this.form.orderType) {
        const customersInfo = this.form.shippers.infos || [];
        this.$refs.dialogSelect.init(customersInfo, this.isDetail, 2);
      } else {
        this.$message({
          message: '请选择订单类型及仓库',
          type: 'warning',
        });
      }
    },
    handleIds(customerInfos) {
      this.form.shippers.infos = customerInfos;
    },
    resetDefaultQa() {
      this.form.configAccept.defaultGoodsQuality = '';
    },
    resetOverchargePercent(resetVal) {
      this.form.configAccept.overchargePercent = resetVal;
    },
    // 获取所有已经添加了的系统任务，新增任务时系统任务不可重复添加，需将已添加的任务禁用
    getSystemTableData() {
      const createOrderTable = this.$refs.createOrderEl.getPureTableData();
      const arrivalReservationTable = this.$refs.arrivalReservation.getPureTableData();
      const arrivalRegistrationTable = this.$refs.arrivalRegistration.getPureTableData();
      const checkAndAcceptTable = this.$refs.checkAndAccept.getPureTableData();
      const groundingTable = this.$refs.grounding.getPureTableData();
      const allTableData = [
        ...createOrderTable,
        ...arrivalReservationTable,
        ...arrivalRegistrationTable,
        ...checkAndAcceptTable,
        ...groundingTable,
      ];
      return allTableData.filter((i) => i.isSystem);
    },
    // 获取指定节点的任务
    getNodeTableData(nodeType) {
      if (!nodeType) return [];
      const getTableDataMap = this.getNodeToEl();
      return getTableDataMap[nodeType].getPureTableData();
    },
    getNodeToEl() {
      return {
        'RECEIPT_ORDER_CREATE_NODE': this.$refs.createOrderEl,
        'RECEIPT_RESERVATION_NODE': this.$refs.arrivalReservation,
        'RECEIPT_CHECK_IN_NODE': this.$refs.arrivalRegistration,
        'RECEIPT_ORDER_ACCEPT_NODE': this.$refs.checkAndAccept,
        'RECEIPT_ORDER_PUTAWAY_NODE': this.$refs.grounding,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  padding: 15px;
}
::v-deep .el-col {
  display:flex;
  justify-content:left;
  align-items:center;
}
.time-interval{
  width: 50px;
}
.wash-box .wash-box-in{
  margin-bottom:5px;
  ::v-deep .el-input{
    width: 120px;
  }
}
.btn-boxs{
  margin-top: 30px;
}
.explain{
  color:#F59A23;
}
.special-color{
  color: #FF0000;
 ::v-deep .el-checkbox__label{
    color: #FF0000;
  }
}
.switch-box{
  width: 100%;
  min-height:500px;
  margin-top: 24px;
  box-shadow: 0 2px 7px 0 rgb(0 25 55 / 10%);
  border-radius: 10px;
}
.el-steps  ::v-deep .el-step.is-horizontal:hover {
  cursor: pointer;
  .el-step__head{
    color: #2AD09C;
    border-color: #2AD09C;
  }
  .el-step__main{
    .el-step__title{
      color: #2AD09C;
    }

  }
}
.el-steps ::v-deep{
        .el-step__head {
            width: 96%;
        }
         .el-step__icon.is-text {
            width: 32px;
            height: 32px;
        }
        .el-step.is-horizontal .el-step__line {
            top: 16px;
        }
        .el-step__head.is-process {
            border-color: #06B880;
        }
        .el-step__head.is-process .el-step__icon.is-text {
            color: #fff;
            background-color: #06B880;
        }
        .el-step__title.is-success{
              color: #606266;
        }
  .el-step {
    .el-step__main {
            position: absolute;
            left: 24px;
            top: 2px;
            height: 26px;
            line-height: 26px;
            background-color: #fff;
            padding: 0 10px 0 16px;
        }
        .el-step__title {
            line-height: 26px;
        }
  }
}
</style>
